import { createStyle } from "@gluestack-style/react";

export const FormControlLabelText = createStyle({
  fontWeight: "$medium",
  color: "$textLight800",
  _dark: {
    color: "$textDark50",
  },
  variants: {
    light: {
      true: {
        color: "$white",
      },
    },
  },
});
